// React
import React from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Actions
import PerformanceAction from 'actions/PerformanceAction';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// Theme
import theme from 'assets/theme/theme';

class DialogEditPerformance extends React.Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        close: PropTypes.func,
        open: PropTypes.bool,
        currentPerformance: PropTypes.object,
        site: PropTypes.object,
        fullScreen: PropTypes.bool,
        sites: PropTypes.array,
    };

    state = {
        orderCount: this.props.currentPerformance.orderCount ? this.props.currentPerformance.orderCount : 0,
        date: this.props.currentPerformance.date ? this.props.currentPerformance.date : new Date(),
        currentSiteId: this.props.currentPerformance.siteId ? this.props.currentPerformance.siteId : this.props.sites[0] ? this.props.sites[0].id : ''
    };

    componentDidUpdate(nextProps) {
        const { open } = this.props;

        if (nextProps.open !== open) {
            this.setState({
                orderCount: this.props.currentPerformance.orderCount ? this.props.currentPerformance.orderCount : 0,
                date: this.props.currentPerformance.date ? this.props.currentPerformance.date : new Date(),
                currentSiteId: this.props.currentPerformance.siteId ? this.props.currentPerformance.siteId : this.props.sites[0] ? this.props.sites[0].id : ''
            });
        }
    }

    handleKeyPress = (event) => {
        const {
            orderCount,
            date
        } = this.state;

        if (event.key === 'Enter') {
            if (this.props.currentPerformance.performanceId) {
                PerformanceAction.updatePerformance({ date, orderCount: parseInt(orderCount), siteId: this.state.currentSiteId }, this.props.currentPerformance.performanceId);
            } else {
                PerformanceAction.addPerformance({ date, orderCount: parseInt(orderCount), siteId: this.state.currentSiteId });
            }
            this.props.close();
        }
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleStartDate = date => {
        this.setState({ date });
    };

    render() {
        const { fullScreen, classes, close, open, sites } = this.props;
        const { orderCount, date, currentSiteId } = this.state;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
            >
                <DialogTitle id='responsive-dialog-title'>{this.props.currentPerformance.performanceId ? translate.i18n('UPDATE_PERFORMANCE') : translate.i18n('ADD_PERFORMANCE')}</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <FormControl className={classes.input}
                        variant='outlined'>
                        <InputLabel>Site</InputLabel>
                        <Select
                            value={currentSiteId}
                            onChange={this.handleChange('currentSiteId')}
                            label={translate.i18n('SITE')}
                        >
                            <MenuItem value=''>
                                <em>None</em>
                            </MenuItem>
                            {sites ?
                                sites.map((site, key) => <MenuItem value={site.id} key={key}>{site.name}</MenuItem>)
                                :
                                null
                            }
                        </Select>
                    </FormControl>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            renderInput={(props) => <TextField {...props} size='small' className={classes.input}/>}
                            label='Date'
                            value={date}
                            onChange={this.handleStartDate}
                            inputVariant='outlined'
                            inputFormat='dd/MM/yyyy'
                            margin='normal'
                        />
                    </LocalizationProvider>
                    <TextField
                        variant='outlined'
                        id='orderCount'
                        type='number'
                        className={classes.input}
                        value={orderCount}
                        label={translate.i18n('ORDER_COUNT')}
                        onChange={this.handleChange('orderCount')}
                        onKeyPress={this.handleKeyPress}
                    />
                </DialogContent>
                <DialogActions>
                    <IconButton color='secondary' onClick={() => {
                        this.props.close();
                    }}>
                        <ClearIcon />
                    </IconButton>
                    <IconButton color='primary' onClick={() => {
                        if (this.props.currentPerformance.performanceId) {
                            PerformanceAction.updatePerformance({ date, orderCount: parseInt(orderCount), siteId: this.state.currentSiteId }, this.props.currentPerformance.performanceId);
                        } else {
                            PerformanceAction.addPerformance({ date, orderCount: parseInt(orderCount), siteId: this.state.currentSiteId });
                        }
                        this.props.close();
                    }}>
                        <DoneIcon />
                    </IconButton>
                    {this.props.currentPerformance.performanceId ?
                        <IconButton style={{ color: theme.palette.red.main }} onClick={() => {
                            PerformanceAction.deletePerformance(this.props.currentPerformance.performanceId);
                            this.props.close();
                        }}>
                            <DeleteIcon />
                        </IconButton>
                        :
                        null
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
    select: {
        marginTop: '10px'
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    input: {
        margin: '5px'
    }
});

export default withStyles(styles)(DialogEditPerformance);
